import styled from "styled-components";

export const DialogContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;
